import React from "react";
import { Alert } from "@mantine/core";

export type Status = { variant: "success" | "error"; message: string } | null;

interface StatusAlertProps {
  status: Status;
  onClose: () => void;
}

const StatusAlert: React.FC<StatusAlertProps> = ({ status, onClose }) =>
  status && (
    <Alert
      color={status.variant === "success" ? "green" : "red"}
      variant="light"
      withCloseButton
      onClose={onClose}
    >
      {status.message}
    </Alert>
  );

export default StatusAlert;
